import { render, staticRenderFns } from "./upmsUpload.vue?vue&type=template&id=84d6dcda&"
import script from "./upmsUpload.vue?vue&type=script&lang=js&"
export * from "./upmsUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports